import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import ReactQuill from 'react-quill';
import Uploader from '../../components/input/Uploader';
import { yupResolver } from '@hookform/resolvers/yup';
import yup from '../../libs/yup/yup';
import Swal from 'sweetalert2';
import { Controller, useForm } from 'react-hook-form';
import { createArticle } from '../../api/sportaloka-client';

const defaultValues = {
  title: '',
  title_en: '',
  slug: '',
  content: '',
  content_en: '',
  type: 'BLOG',
  status: 'PUBLISHED',
  image: ''
};

const schema = yup.object().shape({
  title: yup.string().label('Judul').required('${label} wajib diisi'),
  title_en: yup.string().label('Judul (EN)').required('${label} wajib diisi'),
  slug: yup.string().label('Slug').required('${label} wajib diisi'),
  content: yup.string().label('Konten'),
  content_en: yup.string().label('Konten (EN)'),
  type: yup.string().label('Jenis').required('${label} wajib diisi'),
  status: yup.string().label('Visibility').required('${label} wajib diisi'),
  image: yup.string().label('Gambar Utama')
});

const CreateArticle = () => {
  const [generateFromTitle, setGenerateFromTitle] = useState(true);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const modules = {
    toolbar: [
      [{ font: [] }],
      [{ size: [] }],
      [{ header: [1, 2, 3, 4, 5, 6, false] }],
      [{ color: [] }, { background: [] }],
      [{ script: 'sub' }, { script: 'super' }],
      ['bold', 'italic', 'underline', 'strike'],
      ['blockquote', 'code-block'],
      [{ list: 'ordered' }, { list: 'bullet' }],
      [{ indent: '-1' }, { indent: '+1' }],
      [{ align: [] }],
      ['link', 'image', 'video'],
      ['clean']
    ]
  };

  const stringToSlug = (str) => {
    return str
      .toLowerCase() // Convert to lowercase
      .trim() // Trim whitespace from both sides
      .replace(/[\s_]+/g, '-') // Replace spaces and underscores with a dash
      .replace(/[^\w\-]+/g, '') // Remove all non-word characters
      .replace(/\-\-+/g, '-') // Replace multiple dashes with a single dash
      .replace(/^-+/, '') // Remove dashes from the start
      .replace(/-+$/, ''); // Remove dashes from the end
  };

  const { control, handleSubmit, setValue, getValues } = useForm({
    defaultValues,
    mode: 'onChange',
    resolver: yupResolver(schema)
  });

  const onSubmit = async (values) => {
    try {
      setLoading(true);
      await createArticle(values);
      Swal.fire({
        title: 'Berhasil!',
        text: 'Artikel berhasil ditambahkan',
        icon: 'success',
        confirmButtonText: 'Tutup'
      });
      navigate('/article');
      setLoading(false);
    } catch (error) {
      if (error.response.status === 409) {
        Swal.fire({
          title: 'Gagal!',
          text: `Artikel slug '${values.slug}' sudah ada di database`,
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      } else {
        Swal.fire({
          title: 'Gagal!',
          text: 'Periksa koneksi anda dan coba kembali.',
          icon: 'error',
          confirmButtonText: 'Tutup'
        });
      }
      setLoading(false);
    }
  };

  return (
    <div className="row y-gap-20 justify-between items-center pb-60 lg:pb-40 md:pb-32 article">
      <div className="col-12">
        <div className="d-flex justify-content-between align-items-end">
          <h1 className="text-30 lh-14 fw-600">Buat Artikel</h1>
          <Link to="/article" className="button -md h-50 bg-white text-dark">
            <i className="fa fa-arrow-left mr-10" />
            Kembali
          </Link>
        </div>

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="row mt-20">
            <div className="col-8">
              <div className="bg-white p-4">
                <Controller
                  control={control}
                  name="title"
                  render={({ field: { onChange, onBlur, value }, formState: { errors } }) => (
                    <div>
                      <label className="fw-500">Judul Artikel</label>
                      <input
                        type="text"
                        className={`article__title ${Boolean(errors.title) ? 'form-error' : ''}`}
                        onChange={(val) => {
                          const slug = stringToSlug(val.target.value);
                          onChange(val);
                          if (generateFromTitle) {
                            setValue('slug', slug);
                          }
                        }}
                        onBlur={onBlur}
                        value={value}
                        placeholder="Judul Artikel"
                      />
                    </div>
                  )}
                />

                <div className="article__editor mt-20">
                  <Controller
                    control={control}
                    name="content"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <div>
                        <label className="fw-500">Konten Artikel</label>
                        <ReactQuill
                          theme="snow"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                          modules={modules}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
              <div className="bg-white p-4 mt-20">
                <Controller
                  control={control}
                  name="title_en"
                  render={({ field: { onChange, onBlur, value }, formState: { errors } }) => (
                    <div className="mt-20">
                      <label className="fw-500">Judul Artikel (EN)</label>
                      <input
                        type="text"
                        className={`article__title ${Boolean(errors.title_en) ? 'form-error' : ''}`}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        placeholder="Judul Artikel (EN)"
                      />
                    </div>
                  )}
                />

                <div className="article__editor mt-20">
                  <Controller
                    control={control}
                    name="content_en"
                    render={({ field: { onChange, onBlur, value } }) => (
                      <div>
                        <label className="fw-500">Konten Artikel (EN)</label>
                        <ReactQuill
                          theme="snow"
                          onChange={onChange}
                          onBlur={onBlur}
                          value={value}
                          modules={modules}
                        />
                      </div>
                    )}
                  />
                </div>
              </div>
            </div>
            <div className="col-4">
              <div className="bg-white p-4">
                <Controller
                  control={control}
                  name="type"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div className="form-group">
                      <label className="fw-500">Jenis Artikel</label>
                      <select
                        className="form-control"
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}>
                        <option value="BLOG">Blog</option>
                        <option value="PAGE">Halaman</option>
                      </select>
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="slug"
                  render={({ field: { onChange, onBlur, value }, formState: { errors } }) => (
                    <div className="form-group">
                      <label className="fw-500">Slug Berdasarkan Judul</label>
                      <div className="form-checkbox d-flexform-check items-center">
                        <input
                          onChange={() => {
                            if (!generateFromTitle) {
                              const title = getValues('title');
                              const slug = stringToSlug(title);
                              setValue('slug', slug);
                              setGenerateFromTitle(!generateFromTitle);
                            } else {
                              setValue('slug', '');
                              setGenerateFromTitle('');
                            }
                          }}
                          value={value}
                          className="form-check-input"
                          type="checkbox"
                          id="flexCheckChecked"
                          checked={generateFromTitle}
                        />
                        <div className="form-checkbox__mark">
                          <div className="form-checkbox__icon icon-check" />
                        </div>
                        <br />
                      </div>
                      <input
                        readOnly={generateFromTitle}
                        type="text"
                        className={`article__title ${Boolean(errors.slug) ? 'form-error' : ''}`}
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                        placeholder="Slug"
                      />
                    </div>
                  )}
                />
                <Controller
                  control={control}
                  name="status"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div className="form-group">
                      <label className="fw-500">Visibility</label>
                      <select
                        className="form-control"
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}>
                        <option value="PUBLISHED">Published</option>
                        <option value="DRAFT">Draft</option>
                      </select>
                    </div>
                  )}
                />
              </div>

              <div className="bg-white p-4 mt-20">
                <Controller
                  control={control}
                  name="image"
                  render={({ field: { onChange, onBlur, value } }) => (
                    <div className="form-group">
                      <Uploader
                        id="addIcon"
                        path="article/"
                        accept="image/*"
                        type="text"
                        label="Gambar Utama"
                        onChange={onChange}
                        onBlur={onBlur}
                        value={value}
                      />
                    </div>
                  )}
                />
              </div>
              <button
                type="submit"
                disabled={loading}
                className="button -md h-50 bg-blue-1 text-white w-100 mt-20">
                <i className="fa fa-plus mr-10" />
                {loading ? 'Loading...' : 'Buat Artikel'}
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CreateArticle;
